export default {
  lists: [],
  list: null
};
